export const DEFAULT_USER_NAME = 'System'
